// extracted by mini-css-extract-plugin
export default {"logincontainer":"login_logincontainer__asEYt","logintitle":"login_logintitle__26-0X","loginform":"login_loginform__uZsFD","errormessage":"login_errormessage__fzu86"};